export default __webpack_public_path__ + "static/media/otra-vida-tattoo_logo.6fa5a03c.png";